module.exports = __webpack_public_path__ + "static/media/chatterton_square.19df8319.pdf";